import { render, staticRenderFns } from "./Defesa.vue?vue&type=template&id=1d2a47bb&lang=pug&"
import script from "./Defesa.vue?vue&type=script&lang=js&"
export * from "./Defesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports